export default class DocReady {
  constructor(window, document) {
    this.ready = false;
    this.listeners = [];
    this.window = window;
    this.document = document;
  }

  listen(callback) {
    /**
     * If the dom is ready, call it immediately.
     */
    if (this.ready) {
      callback();

      return this;
    }

    this.listeners.push(callback);

    /**
     * At this point, it may be complete.
     */
    if (this.document.readyState === 'complete') {
      setTimeout(() => this.run(), 0);
    }

    return this;
  }

  run() {
    /**
     * It may get called more than once.
     */
    if (this.ready) {
      return;
    }

    this.ready = true;

    for (let i = 0; i < this.listeners.length; i++) {
      const listener = this.listeners.shift();

      listener();
    }
  }

  static create(window, document) {
    const ready = new DocReady(window, document);

    if (document.addEventListener) {
      document.addEventListener('DOMContentLoaded', () => ready.run(), false);
      window.addEventListener('load', () => ready.run(), false);
    } else {
      // ie
      document.attachEvent('onreadystatechange', () => {
        if (document.readyState == 'complete') {
          ready.run();
        }
      });
      window.attachEvent('onload', () => ready.run());
    }

    return ready;
  }
}

let instance;

export const docReady = (callback) => {
  if (!instance) {
    instance = DocReady.create(window, document);
  }

  instance.listen(callback);
};
